module.exports = __webpack_public_path__ + "static/media/brett-ashley-robinson.947519e4.md";